import React from 'react';
import { NavLink } from "react-router-dom";
import * as ROUTES from '../../constants/routes';

const SignedOutLinks = () => {
    return (
        <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav mr-auto mx-2">
                <li className="nav-item active mobilenavlinks">
                    <NavLink className="nav-link" to={ROUTES.SIGN_IN}>Login</NavLink>
                </li>
                <li className="nav-item active mobilenavlinks">
                    <NavLink className="nav-link" to={ROUTES.SIGN_UP}>Register</NavLink>
                </li>
                {/* <li className="nav-item active">
                    <a className="nav-link" href="https://assettag.stradaimaging.com" target="_blank">Docs</a>
                </li> */}
                {/* <li className="nav-item active">
                    <NavLink className="nav-link" to={ROUTES.TEAM}>Team</NavLink>
                </li> */}
               <li className="nav-item active">
                    <a className="nav-link" href="https://axibuild.com/assettag" target="_blank">About</a>
                </li>
                <li className="nav-item active">
                    <NavLink className="nav-link" to={ROUTES.PRICING}>Pricing</NavLink>
                </li>
                <li className="nav-item active">
                    <NavLink className="nav-link" to={ROUTES.CONTACT}>Contact</NavLink>
                </li>
            </ul>
            <span className="form-inline my-2 my-lg-0">
                <NavLink to={ROUTES.SIGN_IN} style={{ color: 'white' }} className="mobilenavlinksalt">Login</NavLink>
                <div className="vl-topbar" />
                <NavLink to={ROUTES.SIGN_UP} style={{ color: 'white' }} className="mobilenavlinksalt">Register</NavLink>
            </span>
        </div>
    )
}

export default SignedOutLinks;
